import { render, staticRenderFns } from "./InfocertSign.vue?vue&type=template&id=024dc678&scoped=true&"
import script from "./InfocertSign.vue?vue&type=script&lang=js&"
export * from "./InfocertSign.vue?vue&type=script&lang=js&"
import style0 from "./InfocertSign.vue?vue&type=style&index=0&id=024dc678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024dc678",
  null
  
)

export default component.exports